/*
 * @Author: Haotao
 * @Date: 2022-10-17 11:09:11-06 17:54:45
 * @LastEditors: Haotao
 */
import service from '@utils/request'

// 获取任务列表
const getTaskList = (data) => {
  return service({
    url: '/front/userTaskController/userTaskList',
    method: 'post',
    data: data
  })
}

// 获取任务详情
const getTaskDetail = (data) => {
  return service({
    url: '/front/userTaskController/taskDetails',
    method: 'post',
    data: data
  })
}

// 获取简化签约的公司名单
const getSimpleSignList = (data) => {
  return service({
    url: '/front/userTaskController/simpleCompanyNos',
    method: 'post',
    data: data
  })
}

// 静默签署合同
const simpleSign = (data) => {
  return service({
    url: '/front/userTaskController/simpleSign',
    method: 'post',
    data: data
  })
}

// 静默签署合同预览链接
const getSimpleSignPreviewUrl = (data) => {
  return service({
    url: '/front/userTaskController/signPreview',
    method: 'post',
    data: data
  })
}

// 领取任务/确认签约
const receiveTask = (data) => {
  return service({
    url: '/front/userTaskController/taskReceive',
    method: 'post',
    data: data
  })
}
// 查询合同模板
// POST /front/userTaskController/getContractTemplate
const getUserSigningTpl = (data) => {
  return service({
    url: '/front/userTaskController/getContractTemplate/',
    method: 'post',
    data
  })
}

// 用户已签约的公司列表
const getUserSigningList = (taskId) => {
  return service({
    url: '/front/userTaskController/getUserSigning/' + taskId,
    method: 'get'
  })
}
// 查询合同详情
// GET /front/userTaskController/getContractTemplate/{userContractDetailId} 查询已签约协议
const getContractDetail = (userContractDetailId) => {
  return service({
    url: '/front/userTaskController/getContractTemplate/' + userContractDetailId,
    method: 'get'
  })
}

// 薪笔果确认签约
const signXBGTask = (data) => {
  return service({
    url: 'front/userTaskController/signXBG/'+data.taskId,
    method: 'get',
    params: data
  })
}

// 获取用户所有签约的服务商名单
const getAllProviderSignList = (data) => {
  return service({
    url: '/front/userTaskController/getAllSignProviders',
    method: 'post',
    data: data
  })
}

export {
  getTaskList,
  getTaskDetail,
  getSimpleSignList,
  simpleSign,
  getSimpleSignPreviewUrl,
  receiveTask,
  getUserSigningTpl,
  getUserSigningList,
  signXBGTask,
  getContractDetail,
  getAllProviderSignList
}
